module.exports = __webpack_public_path__ + "static/media/RobotoMono-Bold.90190d91.ttf";